import OrderInformation from "@iewcasia/Components/OrderInformation";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useContext } from "react";

const OrderDetailsInformation = () => {
    const order = useContext(OrderStateContext)?.value;
    return <OrderInformation order={order} />;
};

const widgetModule: WidgetModule = {
    component: OrderDetailsInformation as any,
    definition: {
        group: "Order Details",
        displayName: "Information",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
    },
};

export default widgetModule;
